export default "__VITE_ASSET__JI1mzxPg__"